<template>
  <div class="share">
    <div v-if="list && list.length">
      <notice-tips :noticeData="noticeData" :type="'share'" v-if="noticeData"></notice-tips>
      <div v-if="(list && list.length) || loading">
        <position v-for="item in list" :position="item" :type="'share'"></position>
      </div>
    </div>
    <no-data v-if="!list.length && !loading"></no-data>
  </div>
</template>

<script>
  import Position from "@/components/position/position";
  import {getList} from "@/api/share";
  import NoticeTips from "@/components/noticeTips";
  import NoData from "../../components/noData";
export default {
  name: "share-module",
  data() {
    return {
      noticeData: [],
      list: [],
      loading: false,
      pageNo: 1,
      pageSize: 20,
    };
  },
  components: {
    NoData,
    NoticeTips,
    Position,
  },
  methods: {
    onLoad() {
      this.loading = true;
      let params = {pageNo:this.pageNo, pageSize: this.pageSize, ...this.$route.query};
      getList(params).then(res=>{
        if(res.data&&res.data.positionShareEnterpriseVos){
          this.noticeData = res.data;
          res.data.positionShareEnterpriseVos.forEach(item=>{
            this.list = this.list.concat(item.positions);
          })
        }
        console.log(res.data,'<<<<<<<<<<')
        this.list.forEach(item =>{
          item.enterprise = {
            enterpriseId:item.enterpriseId,
            enterpriseLogo:item.enterpriseLogo,
            shortName:item.shortName,
            enterpriseName:item.enterpriseName,
            developStatusStr:item.developStageDesc,
            enterpriseIndustries:item.enterpriseIndustries,
            enterpriseScaleDesc:item.enterpriseScaleDesc
          };
          item.annualSalaryDesc = item.annualSalary;
          item.workExpYearDesc = item.workyearsRequired;
          item.degreeRequiredStr = item.degreeRequired;
          item.refreshTime = '';
        });
      }).catch(err=>{}).finally(()=>{this.loading = false;});
    },
  },
  watch: {
    $route(n,o){
      this.list = [];
      this.pageNo = 1;
      this.onLoad();
    }
  },
  created() {
    this.onLoad();
    this.$store.commit('comp/WX_SHARE',{
      title:'猎上分享 - 职位分享、更易成单、速来推人',
      desc:'重新定义人才服务'
    });
  }
};
</script>
